import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorSlug}/members']['GET'];

const getMembers = async ({ creatorSlug, page, perPage, search, filter, withNames }: ThisApi['params'] & ThisApi['query']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/creators/${creatorSlug}/members`, {
    params: {
      filter,
      page,
      perPage,
      search,
      withNames,
    },
  });
  return response.data;
};

export default getMembers;
